/**
 * Marks a read-cache entry, or a row inside one, that the app wrote for a
 * submission still waiting in its outbox. The record is not on the server
 * yet, so asking the server for it would answer "not found".
 */
export const OFFLINE_PENDING_FIELD = 'offlinePending';

export interface OfflinePendingMark {
  [OFFLINE_PENDING_FIELD]: true;
}

export const isOfflinePending = (value: unknown): boolean =>
  typeof value === 'object' &&
  value !== null &&
  (value as Partial<OfflinePendingMark>)[OFFLINE_PENDING_FIELD] === true;
